module.exports = __webpack_public_path__ + "img/Lobby_Banner1.49f88ac2.png";